__turbopack_context__.v({
  "Byline": "WBp-rW_Byline",
  "CardByline": "WBp-rW_CardByline",
  "CardStatus": "WBp-rW_CardStatus",
  "CategoryTag": "WBp-rW_CategoryTag",
  "Container": "WBp-rW_Container",
  "Content": "WBp-rW_Content",
  "Date": "WBp-rW_Date",
  "Download": "WBp-rW_Download",
  "DownloadButtons": "WBp-rW_DownloadButtons",
  "HasImage": "WBp-rW_HasImage",
  "Highlight": "WBp-rW_Highlight",
  "Image": "WBp-rW_Image",
  "IsNewReport": "WBp-rW_IsNewReport",
  "Large": "WBp-rW_Large",
  "Link": "WBp-rW_Link",
  "Root": "WBp-rW_Root",
  "Root--Card": "WBp-rW_Root--Card",
  "Root--Result": "WBp-rW_Root--Result",
  "Status": "WBp-rW_Status",
  "Subtitle": "WBp-rW_Subtitle",
  "Tags": "WBp-rW_Tags",
  "Title": "WBp-rW_Title",
  "TopContent": "WBp-rW_TopContent",
  "skeleton-loading": "WBp-rW_skeleton-loading",
});
